export default class ActionResponseData {
  /**
   * @param props {Object}
   */
  constructor(props) {
    this.props = {
      url: props.url || null,
      redirect: props.redirect || null,
      fragments: props.fragments || {},
    };
  }

  process() {
    if (this.props.url) {
      window.history.replaceState('', '', this.props.url);
    }

    if (this.props.redirect) {
      window.location.replace(this.props.redirect);
    }

    this.renderFragments();
  }

  renderFragments() {
    Object.entries(this.props.fragments).forEach(([target, fragment]) => {
      if (!(typeof fragment === 'string' || fragment instanceof String)) return;

      const elements = document.querySelectorAll(target);

      elements.forEach((element) => {
        const wrapper = element;
        wrapper.outerHTML = fragment;
        wrapper.dispatchEvent(new Event('update'));
      });
    });
  }
}
